import { useMemo } from 'react';
import {
  textHasHighlightMatches,
  textHasHighlightMatchesAfterOffset,
} from './highlight-utils';
import type { HighlightPattern } from './types';

export type HighlightMatchSummary = {
  inPost: boolean;
  inQuote: boolean;
  inHiddenPost: boolean;
};

const EMPTY: HighlightMatchSummary = {
  inPost: false,
  inQuote: false,
  inHiddenPost: false,
};

export const useHighlightMatchSummary = ({
  postText,
  quoteText,
  patterns,
  maxChars,
}: {
  postText: string | null | undefined;
  quoteText?: string | null;
  patterns: HighlightPattern[] | undefined;
  maxChars: number | null | undefined;
}): HighlightMatchSummary =>
  useMemo(() => {
    if (!patterns?.length) return EMPTY;
    const budgetText = (postText || '').replaceAll('\n', '');
    const inPost = textHasHighlightMatches(budgetText, patterns);
    const inQuote = quoteText
      ? textHasHighlightMatches(quoteText, patterns)
      : false;
    const inHiddenPost =
      inPost && maxChars
        ? textHasHighlightMatchesAfterOffset(budgetText, patterns, maxChars)
        : false;
    return { inPost, inQuote, inHiddenPost };
  }, [postText, quoteText, patterns, maxChars]);
